import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'contact-livechat',
  styleUrl: 'contact-livechat.scss',
})
export class ContactEmail {
  @Prop() type: string;

  getComponentByType(type: string) {
    switch (type) {
      case('login-popup'):
        return <contact-livechat-login-popup />;
    }
  }

  render() {
    return this.getComponentByType(this.type);
  }
}
